import * as IncidentsActions from './incidents.actions';
import * as IncidentsSelectors from './incidents.selectors';

export {IncidentsActions};
export {IncidentsSelectors};
